enum OrderInfoActionType{
    GET_ORDER_INFO_LIST_REQUEST = "GET_ORDER_INFO_LIST_REQUEST",
    GET_ORDER_INFO_LIST_SUCCEEDED = "GET_ORDER_INFO_LIST_SUCCEEDED",
    GET_ORDER_INFO_LIST_FAILED = "GET_ORDER_INFO_LIST_FAILED",
}

export default OrderInfoActionType;
